<template>
  <div class="swiper-answer-wrap" v-if="questions && questions.length">
    <div class="swipper-container answer-wrap" ref="answer">
      <div class="question-count"><span class="current-count">{{activeIndex + 1}}</span> / {{answerInfo.questionCount}}</div>
      <div class="swiper-wrapper">
        <div class="swiper-slide swiper-no-swiping" v-for="question in questions" :key="question.id">
          <div class="swiper-answer">
            <div class="answer-item-wrap">
              <div class="answer-item">
                <div class="title">{{question.description}}{{question.type === 'radio' ? '（单选题）' : '（多选题）'}}</div>
                <!-- 选项 -->
                <div class="title-img" v-if="question.image">
                  <div class="img-bg" :style="bgCover(question.image, 'unchange')" @click="viewImg(question.image)">
                    <div class="view-icon"></div>
                  </div>
                </div>
                <div class="question-wrap">
                  <label class="question-item" :class="[option.answerType, question.type, select[option.id], option.image ? 'image-item' : '']" v-for="(option, idx) in question.options" :key="option.id">
                    <input :type="question.type" :id="option.id" :name="question.name" :value="option.id" v-model="answers" :disabled="!!question.userAnswer" @change="selectAnswer(question, option.id)" />
                    <span class="question-title">{{option.name}}.</span>
                    <div class="question-text" v-if="option.text">{{option.text}}</div>
                    <div class="question-img" v-if="option.image">
                      <div class="img-bg" :style="bgCover(option.image, 'unchange')" @click.stop.prevent="viewImg(option.image, idx)">
                        <div class="view-icon"></div>
                      </div>
                    </div>
                    <div :class="['answer-icon', option.answerType]" v-if="option.answerType"></div>
                    <div class="select-icon" v-if="select[option.id]"></div>
                  </label>
                </div>
                <button :class="answers.length ? 'checkbox-light-btn' : 'checkbox-btn'" v-if="question.type === 'checkbox' && !question.userAnswer" @click="userSendAnswer(question.id, question.type)">确认</button>
                <!-- 答案 -->
                <div class="answer-status" v-if="question.userAnswer">
                  <div :class="[question.isRight ? 'right-answer' : 'fault-answer']">
                    <button :class="['answer-btn', question.isRight ? 'right' : 'fault']">{{question.isRight ? '回答正确' : '回答错误'}}</button>
                    <span class="answer-desc" v-if="!question.isRight">{{`您的选择${question.userAnswer.userAnswers}，正确答案${question.userAnswer.answers}`}}</span>
                  </div>
                  <div class="answer-analysis" v-if="question.userAnswer.analysis">{{question.userAnswer.analysis}}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="page-btn-wrap" :class="!activeIndex ? 'reverse' : ''">
      <button class="pre-btn" v-if="activeIndex" @click="preQuestion">上一题</button>
      <button :class="['next-btn', lightNext]" v-if="activeIndex !== answerInfo.questionCount - 1" @click="nextQuestion">下一题</button>
      <button :class="['submit-btn', lightSubmit]" v-else-if="answerInfo.userStatus === 1" @click="submitPager">提交</button>
    </div>
    <template v-if="showImg">
      <div class="view-wrap" @click="showImg = false">
        <div :class="[smallImg ? 'center-img' : 'view-img']">
          <img class="view" :src="imgUrl"/>
          <div class="close" ></div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import 'swiper/dist/css/swiper.css'
import Swiper from 'swiper/dist/js/swiper.min'

require('@spero/spero-utils/src/constants/native-js-bridge')


let SWIPER = null

export default {
  data () {
    return {
      loading: false,
      activeIndex: 0,
      answers: '',
      select: {},
      showImg: false,
      imgUrl: '',
      smallImg: true,
      swiperOption: {
        initialSlide: 0,
        loop: false,
        // noSwiping: true,
        slidesPerView: 'auto',
        // spaceBetween: 40,
        centeredSlides: true,
        watchSlidesProgress: true,
        on: {
          slideChange: () => {
            this.activeIndex = this.$refs.answer.swiper.activeIndex
          },
          progress () {
            let a = this
            let b
            let c
            let d
            for (b = 0; b < a.slides.length; b++) {
              c = a.slides[b]
              d = c.progress
              let es = c.style
              es.opacity = 1 - Math.min(Math.abs(d / 2), 1)
              es.webkitTransform = es.MsTransform = es.msTransform = es.MozTransform = es.OTransform = es.transform = 'translate3d(0px,0,' + -Math.abs(150 * d) + 'px)'
            }
          },
          setTransition (b) {
            let a = this
            for (var c = 0; c < a.slides.length; c++) {
              let es = a.slides[c].style
              es.webkitTransitionDuration = es.MsTransitionDuration = es.msTransitionDuration = es.MozTransitionDuration = es.OTransitionDuration = es.transitionDuration = b + 'ms'
            }
          }
        }
      },
    }
  },
  props: ['answerInfo', 'id', 'questions'],
  computed: {
    lightSubmit () {
      return this.activeIndex === this.answerInfo.questionCount - 1 &&  this.questions[this.activeIndex].userAnswer ? 'light-submit' : ''
    },
    lightNext () {
      return this.questions[this.activeIndex].userAnswer ? 'light-next' : ''
    }
  },
  watch: {
    activeIndex (val) {
      this.answers = this.questions[val].type === 'radio' ? '' : []
      this.select = {}
      this.$emit('updateActiveIndex', val)
    }
  },
  methods: {
    viewImg (url) {
      // this.$wechat.previewImage({
      //   urls: [url]
      // })
      if (this.inApp) {
        const {event: {action}, action: {scaleImage}} = window.speroBridge
        if (window.YTXBridge) {
          window.YTXBridge.fireEvent(action, {
            actionType: scaleImage,
            data: {
              images: [url],
              selectIndex: 0
            }
          })
        }
      } else {
        let img = new Image()
        img.src = url
        img.onload = () => {
          this.smallImg = img.height < img.width / (window.screen.width / window.screen.height)
          this.showImg = true
          this.imgUrl = url
        }
      }
    },
    submitPager () {
      if (!this.lightSubmit) return
      try {
        this.$rootApi.api(['submitPaper', this.answerInfo.userPid]).then(res => {
          let {code, data, messsage} = res.data
          if (code === 0) {
            console.log('data', data)
            this.$emit('submitPager', data)
          } else {
            this.$toast(messsage)
          }
        })
      } catch (error) {
        this.$toast(error.messsage || error)
      }
    },
    createSwiper () {
      if (SWIPER || !this.questions.length) return
      SWIPER = new Swiper('.answer-wrap', this.swiperOption)
    },
    nextQuestion () {
      if (!this.lightNext) return
      SWIPER.slideNext()
    },
    preQuestion () {
      SWIPER.slidePrev()

    },
    toQuestion(index) {
      if (!SWIPER) this.createSwiper()
      this.$nextTick(() => {
        SWIPER.slideTo(index)
      })
    },
    // 提交答案
    userSendAnswer (id, type) {
      if (type === 'checkbox' && this.answers && !this.answers.length) {
        return
      }
      if (this.loading) return
      this.loading = true
      try {
        this.$rootApi.api(['answer', this.answerInfo.userPid, id], {
          data: {
            userAnswers: type === 'radio' ? [this.answers] : this.answers
          }
        }).then(res => {
          let {code, data, message} = res.data
          if (code === 0) {
            this.select = {}
            this.$emit('updateAnswer', data, this.activeIndex, type)
            setTimeout(() => {
              this.loading = false
            }, 300)
          } else {
            this.$toast(message)
          }
        })
      } catch (err) {
        this.$toast(err.messsage || err)
      }
    },
    // 单选提交 / 多选选择
    selectAnswer (question, value) {
      let {type, id} = question
      console.log(type, this.answers)
      if (type === 'radio') {
        this.userSendAnswer(id, type)
      } else {
        this.select[value] = this.answers.includes(value) ? 'select' : ''
      }
    }
  },
  mounted () {
  },
  created () {
    this.$nextTick(() => {
      this.createSwiper()
    })
  },
}
</script>

<style lang="stylus" scoped>
.page-btn-wrap
  margin: .27rem .36rem 0
  display: flex
  justify-content: space-between
  text-align: center
  &.reverse
    flex-direction: row-reverse
  .pre-btn, .next-btn, .submit-btn
    width: 1.4rem
    height .45rem
    font-size: .16rem
    line-height: .23rem
    border-radius: .25rem
    color: #ffffff
    &.pre-btn
      border: .01rem solid #ffffff
    &.next-btn, &.submit-btn
      font-weight: 700
      background: linear-gradient(to right, #BDBDBD, #D7D7D7)
    &.light-next, &.light-submit
      font-weight: 700
      background: linear-gradient(to right, #E63546, #FA7738)
.question-count
  position: absolute
  top: -.25rem
  right: .36rem
  color: #ffffff
  .current-count
    font-weight: 700
    font-size: .16rem
.swiper-answer-wrap
  width 100%
  height 100%
  position relative
  overflow: hidden
.answer-wrap
  position relative
  width: 100%
  margin-top 15%
  perspective 1300px
.swiper-slide
  width 3.42rem
.swiper-answer
  width 3.42rem
  height calc(100vh - 1.85rem)
  padding 0 .2rem
.answer-item-wrap
  // width 3.02rem
  // // height 4.8rem
  // height calc(100vh - 1.85rem)
  width 100%
  height 100%
  border-radius .13rem
  margin 0 auto
  background #FFFFFF
  padding .21rem 0.04rem .18rem
.answer-item
  width: 100%
  height: 100%
  overflow: scroll
  padding 0 .14rem
  // position absolute
.title
  font-size: .16rem
  line-height: .23rem
  font-weight: 700
  padding-left: .15rem
  position relative
  &:before
    content: ''
    position: absolute
    top: .03rem
    left: 0
    width: .04rem
    height .16rem
    border-radius: .02rem
    background: #FFC300
.title-img
  width: 1.28rem
  height: .72rem
  margin-top: .1rem
  .img-bg
    position: relative
    width: 100%
    height: 100%
    border-radius: .05rem
    .view-icon
      position: absolute
      bottom: .05rem
      right: .05rem
      width: .21rem
      height: .21rem
      z-index 9
      background: url(../images/view-icon.png) center / contain no-repeat
.question-wrap
  padding-top: .04rem
  .question-item
    position relative
    width: 2.66rem
    min-height: .54rem
    margin-top: .1rem
    border: solid .01rem #FFDF98
    display: flex
    align-items: center
    padding 0 .15rem 0 .18rem
    font-size: .12rem
    > input
      position absolute
      opacity 0
    &.radio
      border-radius: .27rem
    &.checkbox, &.image-item
      border-radius: .05rem
    &.right
      border: solid .02rem #2ADEAE
    // &.right-clean
    //   border: dotted .02rem #2ADEAE
    &.fault
      border: solid .02rem #FA7539
    &.select
      border: solid .02rem #FFA149

    .question-text
      flex 1 0 1.65rem
      margin: 0 .24rem 0 .09rem
      width: 1.65rem
      line-height: .16rem
      padding: .11rem 0 .1rem
    .question-img
      flex 1 0 1.65rem
      .img-bg
        width: 1.12rem
        height: .63rem
        margin .04rem 0 .06rem .11rem
        border-radius: .05rem
        position relative
        .view-icon
          position: absolute
          bottom: .05rem
          right: .05rem
          width: .21rem
          height: .21rem
          background: url(../images/view-icon.png) center / contain no-repeat

    .answer-icon
      width: .23rem
      height: .23rem
      border-radius: 50%
      &.right, &.right-clean
        background: url(../images/right-icon.png) center / contain no-repeat
      &.fault
        background: url(../images/fault-icon.png) center / contain no-repeat
    .select-icon
      position: absolute
      right: -.01rem
      bottom: -.01rem
      width: .31rem
      height: .31rem
      background: url(../images/select-icon.png) center / contain no-repeat
      // border-radius: 
.checkbox-btn, .checkbox-light-btn
  display: block
  margin: .27rem auto 0
  width 1.4rem
  height .45rem
  font-size: .16rem
  line-height: .23rem
  font-weight: 700
  color: #ffffff
  border-radius: .25rem
  background: linear-gradient(to right, #BDBDBD, #D7D7D7)
  &.checkbox-light-btn
    background: linear-gradient(to right, #E63546, #FA7738)
.answer-status
  margin-top .18rem
  // position rerlative
  .right-answer
    color: #2ADEAE
  .fault-answer
    color: #FA7539
  .answer-btn
    width: .66rem
    height: .25rem
    border-radius: .24rem
    &.right
      background: #D1F9EF
    &.fault
      background: #FFE5D9
  .answer-desc
    margin-left .07rem
  .answer-analysis
    width 100%
    padding: .04rem .09rem 0
    line-height: .16rem
    color: #999999
    text-align: justify
.view-wrap
  position fixed
  z-index 99
  width 100%
  max-width 750px
  height 100vh
  left 50%
  top 0
  transform translateX(-50%)
.view-img, .center-img
  width 100%
  max-width 750px
  height 100vh
  background rgba(0, 0, 0, 0.8)
  overflow auto
  overflow-scrolling touch
  &.center-img
    display flex
    justify-content: center
    align-items: center
  // padding 1.2rem .1rem 0
  img
    display block
    width 100%
    // margin 1.2rem auto 0
  .close
    position fixed
    top .2rem
    right .2rem
    width .28rem
    height .28rem
    background: url(../images/close-icon.png) center / contain no-repeat
/deep/ .swiper-wrapper
  transform-style preserve-3d

</style>